import { Component, OnInit, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";

@Component({
  selector: "app-confirm-epic-switch-dialog",
  templateUrl: "./confirm-epic-switch-dialog.component.html",
  styleUrls: ["./confirm-epic-switch-dialog.component.scss"],
})
export class ConfirmEpicSwitchDialogComponent extends MzBaseModal {
  readonly result: EventEmitter<any> = new EventEmitter();
  env: any = environment;

  constructor() {
    super();
  }

  yesClick() {
    this.result.emit(true);
  }

  noClick() {
    this.result.emit(false);
  }

  abortClick() {
    this.result.emit("abort");
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/confirm-epic-switch-dialog/confirm-epic-switch-dialog.component.ts